import { render, staticRenderFns } from "./r-plinko-bucket-config-dialog.vue?vue&type=template&id=a3534c48&scoped=true"
import script from "./r-plinko-bucket-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-plinko-bucket-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-plinko-bucket-config-dialog.vue?vue&type=style&index=0&id=a3534c48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3534c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3534c48')) {
      api.createRecord('a3534c48', component.options)
    } else {
      api.reload('a3534c48', component.options)
    }
    module.hot.accept("./r-plinko-bucket-config-dialog.vue?vue&type=template&id=a3534c48&scoped=true", function () {
      api.rerender('a3534c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-bucket-config-dialog.vue"
export default component.exports